import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useState, useContext } from 'react';
import { AuthContext } from '../Context/AuthenticationContext';
// import sunwinLogo from '../../../Assets/sunwin_logo.png';



const Login = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');

    const {setIsAuthenticated, setAccUsername, setUserId} = useContext(AuthContext);

    const handleUsername = (e) => {
        setUsername(e.target.value);
    }

    const handlePassword = (e) => {
        setPassword(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Submitting login form:', { username, password }); // Debug log
        fetch('/api/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                username: username,
                password: password,
                schema: 'sunwin_is'
            })
        }).then(response => {
            console.log('Login response status:', response.status); // Debug log
            if (!response.ok){
                if(response.status === 404){
                    setMessage('User Does not Exist!')
                } else if (response.status === 401){
                    setMessage('Invalid Credential!')
                }
                else{
                    console.error('HTTP ERROR status', response.status);
                    setMessage('An error occured! Try again later');
                }

            }else {
                setUsername('');
                setPassword('');
                return response.json();
            }
        }).then(data => {
            if (data) {
                console.log('Login successful, user data:', data); // Debug log
                // Store authentication state in localStorage
                localStorage.setItem('isAuthenticated', 'true');
                localStorage.setItem('username', data.username);
                localStorage.setItem('userId', data.userId);
                
                setAccUsername(data.username);
                setUserId(data.userId);
                setIsAuthenticated(true);
                navigate('/dashboard');
            }
        })
        .catch(error => {
            console.error('error in adding new user', error)
        })
    }

    return (
        <div className="min-h-screen bg-gray-900 relative">
            {/* Background image with overlay */}
            <div 
                className="absolute inset-0"
                style={{
                    backgroundImage: 'url("/Assets/background.jpg")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                }}
            >
                <div className="absolute inset-0 bg-black opacity-70"></div>
            </div>

            {/* Content with higher z-index to appear above the background */}
            <div className="relative z-10 flex flex-col items-center pt-10">
                <div className="text-center mb-8">
                    {/* Logo and Title Section */}
                    <div className="flex items-center justify-center mb-4">
                        <img
                            src="/Assets/sunwin_logo.png"
                            alt="Sunwin Logo"
                            className="w-24 h-24 mr-4"
                        />
                    </div>
                    <h1 className="text-4xl font-bold text-white mb-2">Sunwin NYC Tool</h1>
                    {/*<h2 className="text-xl text-gray-400">Inventory and Price Management System</h2>*/}
                </div>

                <div className="w-full max-w-md">
                    <form onSubmit={handleSubmit} className="w-full">
                        <div className="bg-gray-900/80 backdrop-blur-sm border border-gray-700 rounded-lg p-8">
                            <div className="mb-6">
                                <label className="block text-gray-300 mb-2">
                                    Enter a Username
                                </label>
                                <input
                                    type="text"
                                    required
                                    value={username}
                                    onChange={handleUsername}
                                    className="w-full p-2 rounded-md bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                            </div>

                            <div className="mb-6">
                                <label className="block text-gray-300 mb-2">
                                    Enter a Password
                                </label>
                                <input
                                    type="password"
                                    required
                                    value={password}
                                    onChange={handlePassword}
                                    className="w-full p-2 rounded-md bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                            </div>

                            <div className="flex justify-center mb-4">
                                <button
                                    type="submit"
                                    className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                >
                                    Login
                                </button>
                            </div>

                            {message && (
                                <div className="text-red-500 text-center mb-4">
                                    <p>{message}</p>
                                </div>
                            )}

                            {/* <div className="text-center">
                                <Link
                                    to="/signup"
                                    className="text-blue-400 hover:text-blue-300 underline"
                                >
                                    Don't have an Account? Signup now!
                                </Link>
                            </div> */}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Login;